<template>
  <v-row class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-sheet class="mb-2">
        <v-skeleton-loader type="article" v-if="loading" />
        <v-col v-else class="px-6 py-4">
          <v-row class="ma-0">
            <h2>Next of kin</h2>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="6" lg="3" class="pa-0">
                  <span class="text-section-title pr-2">First name</span>
                </v-col>
                <v-col cols="12" md="6" lg="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.emergency.firstName"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col
                  cols="12"
                  md="6"
                  lg="3"
                  class="pa-0"
                  :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'start'"
                >
                  <span class="text-section-title pr-2">Surname</span>
                </v-col>
                <v-col cols="12" md="6" lg="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.emergency.lastName"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" lg="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Relationship</div>
                </v-col>
                <v-col cols="12" md="9" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.emergency.relationship"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row class="ma-0 my-3">
            <v-col cols="12" lg="6" class="pa-0">
              <v-row class="ma-0" align="center">
                <v-col cols="12" md="3" class="pa-0">
                  <div class="text-section-title">Contact number</div>
                </v-col>
                <v-col cols="12" md="6" class="pa-0">
                  <v-text-field
                    filled
                    class="field-narrow px-2"
                    v-model="restrictedProfileData.emergency.contactNumber"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['id', 'profileData', 'restrictedProfileData'],
  computed: {
    loading() {
      return !this.profileData || !this.restrictedProfileData
    },
  },
}
</script>

<style>
</style>